import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";

export function useAddCandidateEducation() {
  const client = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: ({ candidate, education }) => {
      return axios.post(`/candidate/${candidate.uuid}/education`, education);
    },
    onSuccess: (data, variables) => {
      client.setQueryData(
        ["candidateDetails", variables.candidate.uuid],
        data.data
      );
    },
  });
}

export function useUpdateCandidateEducation() {
  const client = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: ({ candidate, education }) => {
      const formData = new FormData();
      for (const [key, val] of Object.entries(education)) {
        formData.append(key, val);
      }
      // if a new image is uploaded (image_data), remove the image url (logo)
      if (formData.has("image_data")) {
        formData.delete("logo");
      }
      // if image_data is null, remove it
      if (formData.get("image_data") === "null") {
        formData.delete("image_data");
      }
      formData.append("_method", "PATCH"); // Laravel will treat this as a PATCH request

      return axios.post(
        `/candidate/${candidate.uuid}/education/${education.id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    },
    onSuccess: (data, variables) => {
      client.setQueryData(["candidateDetails", variables.candidate.uuid], data);
    },
  });
}

export function useRemoveCandidateEducation() {
  const client = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: ({ candidate, educationId }) => {
      return axios.delete(
        `/candidate/${candidate.uuid}/education/${educationId}`
      );
    },
    onSuccess: (data, variables) => {
      client.setQueryData(["candidateDetails", variables.candidate.uuid], data);
    },
  });
}

export function useReorderCandidateEducation() {
  const client = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: ({ candidate, order }) => {
      return axios.post(`/candidate/${candidate.uuid}/education/reorder`, {
        order,
      });
    },
    onSuccess: (data, variables) => {
      client.setQueryData(
        ["candidateDetails", variables.candidate.uuid],
        data
      );
    },
  });
}
